<template>
  <div>
    <b-card-group deck>
      <b-card class='mb-2 p-2 bg-primary-4 stat mx-auto' title="Created">
        <h3>{{project.items_count}}</h3>
      </b-card>

      <b-card class='mb-2 p-2 bg-primary-5 stat mx-auto' title="Visit rate">
        <h3>{{visit_rate}}%</h3>
      </b-card>

      <b-card class='mb-2 p-0 bg-primary-1 stat mx-auto' title="Watch %" no-body>
        <b-card-title class="mt-4 mb-4" style="margin-top: 28px !important;">
          <span v-if="currentInfo.label == null">Watch duration</span>
          <span v-else>{{currentInfo.value}} watched {{currentInfo.label}}</span>
        </b-card-title>

        <Chart v-if="percentages && percentages.length >0" :data='percentages' :currentInfo="currentInfo"/>
      </b-card>

      <b-card class='mb-2 p-2 bg-primary-1 stat mx-auto' title="Click rate">
        <h3>{{click_rate}}%</h3>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
import Chart from "@/components/Chart.vue"

export default {
  name: 'ProjectAnalytics',
  props: ['project'],
  components: {Chart},
  data() {
    return {
      currentInfo: {label: null, value: null}
    }
  },
  computed: {
    visit_rate() {
      if (!this.project.items_count) {return 0}
      return ((this.project.visited || 0) / this.project.items_count * 100).toFixed(1)
    },
    played_rate() {
      if (!this.project.items_count) {return 0}
      return ((this.project.played || 0) / this.project.items_count * 100).toFixed(1)
    },
    click_rate() {
      if (!this.project.items_count) {return 0}
      return ((this.project.clicked || 0) / this.project.items_count * 100).toFixed(1)
    },
    percentages() {
      let percentages = []
      let duration = this.project.duration

      if (!duration || !this.project.watch_seconds) {
        for (let i=0; i<11; i++) {
          percentages.push({day: `${i*10}%`, seconds: 0, value: 0})
        }

        return percentages
      }

      let total_watchers = 0
      for (let second in this.project.watch_seconds) {
        total_watchers = total_watchers + this.project.watch_seconds[second]
      }

      for (let i=0; i<11; i++) {
        percentages.push({day: `${i*10}%`, seconds: Math.floor((duration/10) * i), value: total_watchers})
      }

      for (let percent of percentages) {
        if (percent.day === '0%') {
          continue
        }

        for (let second in this.project.watch_seconds) {
          if (Math.floor(duration) == Math.floor(second)) {
            continue
          }

          if (second <= percent.seconds) {
            percent.value = percent.value - this.project.watch_seconds[second]
          }
        }
      }

      return percentages
    }
  }
}
</script>

<style>

</style>
